import { useMentorAIUsage } from '../../Hooks/useMentorAIUsage'
import { useHelpRequestsReport } from '../../Hooks/useHelpRequestsReport'
import { Report } from '../Report'

export const AIReports = () => {
    const { chartProps: helpRequestsProps } = useHelpRequestsReport()
    const { chartProps: mentorUsageProps } = useMentorAIUsage()

    return (
        <section>
            <Report {...helpRequestsProps} />
            <Report {...mentorUsageProps} />
        </section>
    )
}
